import { render } from "./yourtechpartner.vue?vue&type=template&id=1bbc6e36&scoped=true"
import script from "./yourtechpartner.vue?vue&type=script&lang=js"
export * from "./yourtechpartner.vue?vue&type=script&lang=js"

import "./yourtechpartner.vue?vue&type=style&index=0&id=1bbc6e36&scoped=true&lang=css"

import exportComponent from "C:\\Users\\amaan\\encanto-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bbc6e36"]])

export default __exports__